import ApiConfig from "../api/ApiConfig";
import { simpleGetCall } from "../api/ApiServices";
import { AppContext } from "./AppContext";
import io from "socket.io-client";

import React, { useEffect, useState } from "react";
const AppState = (props) => {
  const [sidebar, setSidebar] = useState(false);
 
  const [Dark, setDark] = useState("lightMode");
  const [Prescription, setPrescription] = useState(false);
  const [MenuCategoryList, setMenuCategoryList] = useState([]);
  const [countCart, setCountCart] = useState(false)
  const [restaurant_status, setRestaurant] = useState(true)
  const [isConnected, setIsConnected] = useState(false);
  const [loginData, setLoginData] = useState({})
   const [selected_location, set_selected_location] = useState( JSON.parse(localStorage.getItem('user_selected_location')) || {});
   const [validateOrderCapacityType, setValidateOrderCapacityType] = useState(localStorage.getItem('validate_order_capacity_type') || null);
   const [restaurantDetails, setRestaurantDetails] = useState(JSON.parse(localStorage.getItem('selected_restaurant_details')) || {});
const [deliveryDistance, setDeliveryDistance] = useState(null);
const [UserID, setUserID] = useState("");
const [defaultImgs, setDefaultImgs] = useState(JSON.parse(localStorage.getItem('defaultImgs' || {})));

  const [loginType, setLoginType] = useState("zamzam");
const [restaurantGeofenceRadiusKm, setRestaurantGeofenceRadiusKm] = useState(Number(localStorage.getItem('restaurantGeofenceRadiusKm')) || 6)
    const [restaurantDispatchSettings, setRestaurantDispatchSettings] = useState({
    dispatch_setting_km_range: 6,
  });
  const [restaurantConfig, setRestaurantConfig] = useState( JSON.parse(localStorage.getItem('restaurant_config')) || [])

  const [jobApiRefresh, setJobApiRefresh] = useState(0);

const [storesList, setStoresList] = useState( JSON.parse(localStorage.getItem('store_list')) || []);
  console.log("storesList",storesList);
// const [selectedStore, setSelectedStore] = useState(localStorage.getItem('selectedStore') ? localStorage.getItem('selectedStore') : storesList.length > 1 ? storesList[0]?.value : null );
const [selectedStroeObject, setSelectedStoreObject] = useState(null); 

let store = localStorage.getItem("selectedStore");

// Handle invalid or undefined values
if (store === "undefined" || store === null) {
  store = null;
} else {
  try {
    store = JSON.parse(store);
  } catch (e) {
    store = null;
  }
}

const [selectedStore, setSelectedStore] = useState(
  store ?? (storesList.length > 1 ? storesList[0]?.value : null)
);


  const [socket, setSocket] = useState();
const [searchTerm, setSearchTerm] = useState("");
console.log("searchTerm",searchTerm)


  // useEffect(() => {

  //     setSocket(
  //       io(
  //         `${ApiConfig.BASE_URL}`,
          
  //       )
  //     );

  // }, []);

useEffect(  () => {
  

    if (true) {
      const newSocket = io(ApiConfig.BASE_URL);

      setSocket(newSocket);

      newSocket.on("connect", () => {
        console.log("Socket connected:", newSocket.id);
        setIsConnected(true);
      });

      newSocket.on("disconnect", () => {
        console.log("Socket disconnected");
        setIsConnected(false);
      });

      newSocket.on("connect_error", (err) => {
        console.error("Socket connection error:", err.message);
        setIsConnected(false);
      });


//           newSocket.on(`${selectedStore}/updated-menu`, (data) => {
//   if (true) {
//     console.log("Menu updated:", data);
//   }
// });


//       if(loginType === "agent" || loginType === "Agent") {
    


//     newSocket.on("new_order_notification", (data) => {
//   if (data?.extra_data?.restaurant_id == selectedStore) {
//     enqueueNotification({
//         notifyFn: notifySuccess,
//       soundFn: playSuccessSound,
//       text: data?.body,
    
//     });
//   }
// });

  


//     newSocket.on("order_cancelled_notification", (data) => {
//   if (data?.restaurant_id == selectedStore) {
//     enqueueNotification({
//       notifyFn: notifyError,
//       soundFn: playErrorSound,
//       text: data?.message,
      
//     });
//   }
// });

    // --- CLEANUP ---
    return () => {
      // newSocket.off("new_order_notification");
      // newSocket.off("order_cancelled_notification");
      newSocket.disconnect();
    };

    
    }
  
  }, []);


const subscribeToEvent = (eventName, callback) => {
  if (!socket) return () => {};

  socket.on(eventName, callback);

  return () => {
    socket.off(eventName, callback);
  };
};


return (
    <div>
      <AppContext.Provider
        value={{
          sidebar,
          storesList, setStoresList,
          setSidebar,
          deliveryDistance, setDeliveryDistance,
          Dark,
          setDark,
          loginData, setLoginData,
          socket, setSocket,
          Prescription,
          loginType, setLoginType,
          setPrescription,  selectedStore, setSelectedStore,
          setCountCart, countCart,
          setRestaurant ,restaurant_status,
          setRestaurantDetails, restaurantDetails,
          setRestaurantDispatchSettings , restaurantDispatchSettings,
          set_selected_location, selected_location,
          restaurantGeofenceRadiusKm, setRestaurantGeofenceRadiusKm,
          MenuCategoryList , setMenuCategoryList,
          setSelectedStoreObject, selectedStroeObject,
          UserID, setUserID, setJobApiRefresh, jobApiRefresh,
          searchTerm, setSearchTerm , setRestaurantConfig ,restaurantConfig,
           isConnected,
    subscribeToEvent, setDefaultImgs, defaultImgs,
    validateOrderCapacityType, setValidateOrderCapacityType
        }}
      >
        {props.children}
      </AppContext.Provider>
    </div>
  );
};

export default AppState;
